import { IGatsbyImageData } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import Image from 'src/elements/image/image';
import {
  CaseStudyCarouselContainer,
  CaseStudy,
  CaseStudyTitle,
  CaseStudyImage,
  RightArrow,
  LeftArrow
} from './caseStudies.carousel.syles';
import Heading from 'elements/typography/heading'
import { Link } from 'gatsby'
import Slider from 'react-slick'

export interface CaseStudyCarouselProps {
  posts: {
    title: string;
    image: IGatsbyImageData;
    slug: string;
  }[]
}

const CaseStudyCarousel = ({ posts }: CaseStudyCarouselProps): JSX.Element => {
  const [ isDragging, setIsDragging ] = useState(false);
  const [ isSwiping, setIsSwiping ] = useState(false);

  const sliderSettings = {
    slidesToShow: 3,
    nextArrow: <RightArrow />,
    prevArrow: <LeftArrow />,
    beforeChange: () => {
      setIsDragging(true);
    },
    afterChange: () => {
      setIsDragging(false);
    },
    swipeEvent: () => {
      setIsSwiping(true)

      setTimeout(() => setIsSwiping(false), 1000) // If the user starts to drag but stays in the same slide
    },
    onSwipe: () => setIsSwiping(false),
    responsive: [
      {
        breakpoint: 950, // subLg size
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 700, // sm size
        settings: {
          slidesToShow: 1
        }
      }
    ]
  }

  return (
    <CaseStudyCarouselContainer>
      <Slider {...sliderSettings}>
        {
          posts.map((post, index) => (
            <Link
              to={`/case-studies/${post.slug}`}
              key={index}
              onClick={(event) => (isDragging || isSwiping) && event.preventDefault()}
              onDragStart={(event) => {
                event.stopPropagation()
                event.preventDefault()
              }}
              onDrag={(event) => {
                event.stopPropagation()
                event.preventDefault()
              }}
            >
              <CaseStudy>
                <CaseStudyImage>
                  <Image childImageSharp={ post.image } alt={post.title} />
                </CaseStudyImage>
                <CaseStudyTitle>
                  <Heading
                    text={post.title}
                    size="1.3rem"
                    sizeSubLg="1.1rem"
                    weight="normal"
                    align="left"
                  />
                </CaseStudyTitle>
              </CaseStudy>
            </Link>
          ))
        }
      </Slider>
    </CaseStudyCarouselContainer>
  )
}

export default CaseStudyCarousel;
